import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Entity } from 'src/app/core/models/entity.model';
import { MultilevelItem } from 'src/app/core/models/multilevel-selector.model';
import { User } from 'src/app/core/models/user.model';
import { ConfigService } from 'src/app/core/services/config.service';
import { FitService } from 'src/app/core/services/fit.service';
import { GazeMapService } from 'src/app/core/services/gaze-map.service';
import { LicenseService } from 'src/app/core/services/license.service';
import * as utils from 'src/app/shared/helpers/utils';


@Component({
  selector: 'hbo-multi-select-multi-level',
  templateUrl: './multi-select-multi-level.component.html',
  styleUrls: ['./multi-select-multi-level.component.scss']
})
export class MultiSelectMultiLevelComponent {

  multilevelSelectorHead: string = 'DATATABLE.FILTERS.EVERYENTITY';
  multilevelSelectorHeadNumber!: number;
  clearSelectorPB!: boolean;
  maxLevel!: number;
  minLevel!: number;
  selectorSearch!: string;
  allSelected!: boolean;

  @Input("search") search!: string | undefined;
  @Input("typeData") typeData!: string;
  @Output('callback') callback = new EventEmitter;
  @ViewChild('selector') selector!: ElementRef;
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: { target: any; }): void {
    if (!this.selector.nativeElement.contains(event.target)) {
      // clicked outside => close dropdown list
      //this.selectorSearch = '';
      //this.data.map((item: MultilevelItem) => this.iterateItemVisible(item));
      this.showDropdown = false;

    }
  }

  data: MultilevelItem[] = [];

  user: User = utils?.localStorageGetItem('user');

  showDropdown!: boolean;

  constructor(
    private configSvc: ConfigService,
    public gazeMapService: GazeMapService,
    public fitService: FitService,
    public licenseService: LicenseService
  ) {
    this.user.childEntities = this.configSvc.currentConfigValue.childEntities;

  }

  iterateItemUnselect(_item: MultilevelItem) {
    //console.log(_item);
    _item.selected = false;
    _item.childs! = _item.childs!.sort((a, b) => a.target.name.localeCompare(b.target.name)),
      _item.childs?.map((item: MultilevelItem) => this.iterateItemUnselect(item))
  }
  iterateItemVisible(_item: MultilevelItem) {
    _item.visible = true;
    _item.childs?.map((item: MultilevelItem) => this.iterateItemVisible(item))
  }

  ngOnInit(): void {
    this.search
      ? this.selectorSearch = this.search
      : null;
    this.maxLevel = Math.max(...this.user.childEntities!.map(o => o.entityTypeId));
    this.minLevel = this.user.entity.entityTypeId <= 4 ? this.user.entity.entityTypeId : Math.min(...this.user.childEntities!.map(o => o.entityTypeId));
    let partners: MultilevelItem[] = [];
    switch (this.typeData) {
      case 'package':
        this.licenseService.currentPackageConfigValue.allSelected != undefined ? this.allSelected = this.licenseService.currentPackageConfigValue.allSelected : this.allSelected = true;
        partners = this.licenseService.currentPackageConfigValue.partners!;
        break;
      case 'gazeMaps':
        this.gazeMapService.currentGazeMapConfigValue.allSelected != undefined ? this.allSelected = this.gazeMapService.currentGazeMapConfigValue.allSelected : this.allSelected = true;
        partners = this.gazeMapService.currentGazeMapConfigValue.partners!;
        break;
      case 'fits':
        this.fitService.currentFitConfigValue.allSelected != undefined ? this.allSelected = this.fitService.currentFitConfigValue.allSelected : this.allSelected = true;
        partners = this.fitService.currentFitConfigValue.partners!;
        break;
      default:
        break;
    }
    partners
      ? this.data = partners
      : (
        this.minLevel <= 4
          ? this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: this.user.entity, childs: this.setLevel(this.user.entity) })
          : this.user.childEntities!
            .filter((item: Entity) => item.entityTypeId == this.minLevel)
            .map((item: Entity) => {
              this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: item, childs: this.setLevel(item) });
            })
      )
    this.allSelected
      ? this.data.map((item: MultilevelItem) => this.iterateItemUnselect(item))
      : null;
    this.setmultilevelSelectorHeadNumber();
  }

  setLevel(_item: Entity) {
    let levelChilds: MultilevelItem[] = [];
    this.user.childEntities!
      .filter((item: Entity) => item.parentEntityId == _item.id)
      .map((child: Entity) => {
        levelChilds.push({ visible: true, opened: true, all: true, selected: false, level: child.entityTypeId, type: child.entityTypeId, target: child, childs: this.setLevel(child) });
      });
    return levelChilds
  }
  toogleDropdown() {
    this.showDropdown = !this.showDropdown;
    console.log(this.data);
  }
  toogle(_item: MultilevelItem) {
    _item.opened = !_item.opened;
  }
  change(e: any, _item: MultilevelItem): void {
    switch (this.typeData) {
      case 'package':
        this.clearSelectorPB = true;
        _item.selected && _item.childs?.filter((item: MultilevelItem) => item.selected).length == _item.childs!.length
          ? _item.all = true
          : _item.all = false;
        _item.selected && !_item.childs?.filter((item: MultilevelItem) => item.selected).length
          ? (
            _item.childs?.map((item: MultilevelItem) => {
              item.all = true;
              item.selected = true;
            })
          )
          : null;
        /*this.iterateItems();*/
        this.callback.emit('change');
        break;
      case 'gazeMaps':
        this.clearSelectorPB = true;
        _item.selected && _item.childs?.filter((item: MultilevelItem) => item.selected).length == _item.childs!.length
          ? _item.all = true
          : _item.all = false;
        _item.selected && !_item.childs?.filter((item: MultilevelItem) => item.selected).length
          ? (
            _item.childs?.map((item: MultilevelItem) => {
              item.all = true;
              item.selected = true;
            })
          )
          : null;
        /*this.iterateItems();*/
        this.callback.emit('change');
        break;
      case 'fits':
        this.clearSelectorPB = true;
        _item.selected && _item.childs?.filter((item: MultilevelItem) => item.selected).length == _item.childs!.length
          ? _item.all = true
          : _item.all = false;
        _item.selected && !_item.childs?.filter((item: MultilevelItem) => item.selected).length
          ? (
            _item.childs?.map((item: MultilevelItem) => {
              item.all = true;
              item.selected = true;
            })
          )
          : null;
        /*this.iterateItems();*/
        this.callback.emit('change');
        break;
      default:
        break;
    }
  }
  iterateItem(_item: MultilevelItem, _shops_selected: Entity[]) {
    if (_item.target.entityTypeId != 4) {
      switch (this.typeData) {
        case 'package':
          _item.selected ? _shops_selected.push(_item.target) : null;
          break;
        default:
          break;
      }
      _item.childs!.map((item: MultilevelItem) => {
        this.iterateItem(item, _shops_selected)
      })
    } else {
      _item.selected ? _shops_selected.push(_item.target) : null;
    }
  }

  iterateEveryUncheck(_level: MultilevelItem[], _selected: MultilevelItem) {
    console.log(_level);
    if (_selected.target) {
      console.log(_selected.target);
      _level.map((item: MultilevelItem) => {
        console.log(item);
        item.target.id != _selected.target.id
          ? (
            item.selected = false,
            console.log(item),
            this.iterateEveryUncheck(item.childs!, _selected)
          )
          : this.iterateEveryUncheck(item.childs!, _selected);
      })
    }
  }

  setShops(e: any) {
    switch (this.typeData) {
      default:
        switch (e) {
          case 'iterate':
            this.iterateItems();
            break;
          case 'change':
            this.clearSelectorPB = true;
            this.callback.emit(e);
            break;
          default:
            this.clearSelectorPB = true;
            this.iterateItems();
            this.callback.emit(e);
            break;
        }
        this.iterateItems();

        break;
    }

  }

  visibleEntity(e: { item: MultilevelItem, value: boolean }) {
    //console.log(e);
    e.item.visible = e.value;
  }

  iterateItems() {
    let shops_selected: Entity[] = [];
    this.data.map((item: MultilevelItem) => {
      this.iterateItem(item, shops_selected)
    })
    switch (this.typeData) {
      case 'package':
        this.multilevelSelectorHeadNumber = this.user.childEntities!.length;
        break;
      default:
        this.multilevelSelectorHeadNumber = this.user.childEntities!.filter((item: Entity) => item.entityTypeId == 4)!.length;
        break;
    }

    shops_selected.length == this.multilevelSelectorHeadNumber
      || !shops_selected.length
      ? this.multilevelSelectorHead = 'DATATABLE.FILTERS.EVERYENTITY'
      : shops_selected.length > 1
        ? this.multilevelSelectorHead = 'DATATABLE.FILTERS.MANYENTITIES'
        : shops_selected.length == 1
          ? this.multilevelSelectorHead = shops_selected[0].name
          : this.multilevelSelectorHead = 'DATATABLE.FILTERS.ENTITY'
    this.multilevelSelectorHeadNumber = shops_selected.length;
    switch (this.typeData) {
      case 'package':
        this.licenseService.setCurrentPackageParamConfig('partners', this.data);
        this.licenseService.setCurrentPackageParamConfig('shops_selected', shops_selected);
        (!shops_selected || !shops_selected.length)
          || shops_selected && shops_selected.length == this.user.childEntities!.filter((item: Entity) => item.entityTypeId == 4)!.length
          ? this.allSelected = true
          : this.allSelected = false;
        this.licenseService.setCurrentPackageParamConfig('allSelected', this.allSelected);
        break;
      case 'gazeMaps':
        this.gazeMapService.setCurrentGazeMapParamConfig('partners', this.data);
        this.gazeMapService.setCurrentGazeMapParamConfig('shops_selected', shops_selected);
        (!shops_selected || !shops_selected.length)
          || shops_selected && shops_selected.length == this.user.childEntities!.filter((item: Entity) => item.entityTypeId == 4)!.length
          ? this.allSelected = true
          : this.allSelected = false;
        this.gazeMapService.setCurrentGazeMapParamConfig('allSelected', this.allSelected);
        break;
      case 'fits':
        this.fitService.setCurrentFitParamConfig('partners', this.data);
        this.fitService.setCurrentFitParamConfig('shops_selected', shops_selected);
        (!shops_selected || !shops_selected.length)
          || shops_selected && shops_selected.length == this.user.childEntities!.filter((item: Entity) => item.entityTypeId == 4)!.length
          ? this.allSelected = true
          : this.allSelected = false;
        this.fitService.setCurrentFitParamConfig('allSelected', this.allSelected);
        break;
      default:
        break;
    }

  }
  setmultilevelSelectorHeadNumber() {
    if (!this.user.childEntities!.length) {
      this.multilevelSelectorHead = this.user.entity.name;
    } else {
      let shops_selected;
      switch (this.typeData) {
        case 'package':
          this.multilevelSelectorHeadNumber = this.user.childEntities!.length;
          shops_selected = this.licenseService.currentPackageConfigSubject.value.shops_selected!;
          break;
        case 'gazeMaps':
          this.multilevelSelectorHeadNumber = this.user.childEntities!.filter((item: Entity) => item.entityTypeId == 4)!.length;
          shops_selected = this.gazeMapService.currentGazeMapConfigSubject.value.shops_selected!;
          break;
        case 'fits':
          this.multilevelSelectorHeadNumber = this.user.childEntities!.filter((item: Entity) => item.entityTypeId == 4)!.length;
          shops_selected = this.fitService.currentFitConfigSubject.value.shops_selected!;
          break;
        default:
          break;
      }
      (!shops_selected || !shops_selected.length)
        || shops_selected && shops_selected.length === this.multilevelSelectorHeadNumber
        ? (this.allSelected = true, this.multilevelSelectorHead = 'DATATABLE.FILTERS.EVERYENTITY')
        : (
          this.allSelected = false,
          shops_selected
            ? (
              shops_selected.length > 1
                ? this.multilevelSelectorHead = 'DATATABLE.FILTERS.MANYENTITIES'
                : shops_selected.length == 1
                  ? this.multilevelSelectorHead = shops_selected[0].name
                  : this.multilevelSelectorHead = 'DATATABLE.FILTERS.ENTITY',
              this.clearSelectorPB = true,
              this.multilevelSelectorHeadNumber = shops_selected.length
            )
            : null
        )
    }
    switch (this.typeData) {
      case 'package':
        this.licenseService.setCurrentPackageParamConfig('allSelected', this.allSelected);
        break;
      case 'gazeMaps':
        this.gazeMapService.setCurrentGazeMapParamConfig('allSelected', this.allSelected);
        break;
      case 'fits':
        this.fitService.setCurrentFitParamConfig('allSelected', this.allSelected);
        break;
      default:
        break;
    }

  }

  clear(e: any) {
    this.allSelected = true;
    this.clearSelectorPB = false;
    this.search = '';
    this.data = [];

    switch (this.typeData) {
      case 'package':
        this.licenseService.setCurrentPackageParamConfig('partners', null);
        this.licenseService.setCurrentPackageParamConfig('shops_selected', null);
        this.licenseService.setCurrentPackageParamConfig('allSelected', true);
        /*this.licenseService.currentPackageConfigValue.partners
          ? this.data = this.licenseService.currentPackageConfigValue.partners
          : this.minLevel == 2
            ? this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: this.user.entity, childs: this.setLevel(this.user.entity) })
            : this.user.childEntities
              .filter((item: Entity) => item.entityTypeId == this.minLevel)
              .map((item: Entity) => {
                this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: item, childs: this.setLevel(item) });
              });*/

        break;
      case 'gazeMaps':
        this.gazeMapService.setCurrentGazeMapParamConfig('partners', null);
        this.gazeMapService.setCurrentGazeMapParamConfig('shops_selected', null);
        this.gazeMapService.setCurrentGazeMapParamConfig('allSelected', true);
        /*this.gazeMapService.currentGazeMapConfigValue.partners
          ? this.data = this.gazeMapService.currentGazeMapConfigValue.partners
          : this.minLevel == 2
            ? this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: this.user.entity, childs: this.setLevel(this.user.entity) })
            : this.user.childEntities
              .filter((item: Entity) => item.entityTypeId == this.minLevel)
              .map((item: Entity) => {
                this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: item, childs: this.setLevel(item) });
              });*/
        break;
      case 'fits':
        this.fitService.setCurrentFitParamConfig('partners', null);
        this.fitService.setCurrentFitParamConfig('shops_selected', null);
        this.fitService.setCurrentFitParamConfig('allSelected', true);
        /*this.fitService.currentFitConfigValue.partners
          ? this.data = this.fitService.currentFitConfigValue.partners
          : this.minLevel == 2
            ? this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: this.user.entity, childs: this.setLevel(this.user.entity) })
            : this.user.childEntities
              .filter((item: Entity) => item.entityTypeId == this.minLevel)
              .map((item: Entity) => {
                this.data.push({ visible: true, opened: true, all: true, selected: false, level: this.minLevel, type: this.minLevel, target: item, childs: this.setLevel(item) });
              });*/

        break;
      default:
        break;
    }
    this.ngOnInit();
    this.callback.emit('change');

  }

  onChange(e: Event, _type?: string) {
    switch (_type) {
      case 'search':

        break;
      default:
        break;
    }
    this.callback.emit('change');
  }
  applyFilters() {

  }
}
